import React, { useState } from 'react';
import { Plus, Trash2, MoreHorizontal } from 'lucide-react';
import { stripMarkdown } from './RowListEditors';
import AutoGrowingTextarea from './AutoGrowingTextarea';

const TableRow = ({ row, rIdx, headers, readOnly, updateCell, removeRow }) => {
    const [isHovered, setIsHovered] = useState(false);
    
    return (
        <tr 
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{ 
                background: rIdx % 2 === 0 ? '#fff' : '#FAFAFA',
                borderBottom: '1px solid #E8EDF2',
                transition: 'background 0.15s'
            }}
        >
            {headers.map(h => (
                <td key={h} style={{ padding: '8px 12px', verticalAlign: 'top' }}>
                    <AutoGrowingTextarea 
                        disabled={readOnly} 
                        value={stripMarkdown(row[h] ?? '')} 
                        onChange={(e) => updateCell(rIdx, h, e.target.value)} 
                        rows={1}
                        style={{
                            width: '100%',
                            fontSize: 13,
                            color: '#1E293B',
                            background: 'transparent',
                            border: 'none',
                            outline: 'none',
                            padding: 0,
                            resize: 'none',
                            overflow: 'hidden',
                            minHeight: 20,
                            fontFamily: 'inherit'
                        }} 
                    />
                </td>
            ))}
        </tr>
    );
};

const DynamicTableEditor = ({ value, onChange, readOnly }) => {
    const { column_headers: headers = [], content: rows = [] } = value || {};

    const updateCell = (rowIdx, col, val) => {
        const next = rows.map((r, i) => i === rowIdx ? { ...r, [col]: val } : r);
        onChange({ column_headers: headers, content: next });
    };
    const addRow = () => {
        const empty = headers.reduce((acc, h) => ({ ...acc, [h]: '' }), {});
        onChange({ column_headers: headers, content: [...rows, empty] });
    };
    const removeRow = (idx) => onChange({ column_headers: headers, content: rows.filter((_, i) => i !== idx) });

    if (!headers.length) {
        return <p style={{ color: '#94A3B8', fontSize: 13 }}>No column headers found for this table.</p>;
    }

    return (
        <div style={{ overflowX: 'auto', borderRadius: 8, border: '1px solid #E8EDF2' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                    <tr style={{ background: '#F8F9FA', borderBottom: '1px solid #E2E8F0' }}>
                        {headers.map(h => (
                            <th 
                                key={h} 
                                style={{ 
                                    padding: '10px 12px', 
                                    textAlign: 'left', 
                                    fontWeight: 600, 
                                    color: '#475569', 
                                    whiteSpace: 'nowrap',
                                    fontSize: 12,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.02em',
                                    position: 'sticky',
                                    top: 0,
                                    background: '#F8F9FA',
                                    zIndex: 1
                                }}
                            >
                                {h}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, rIdx) => (
                        <TableRow 
                            key={rIdx}
                            row={row}
                            rIdx={rIdx}
                            headers={headers}
                            readOnly={readOnly}
                            updateCell={updateCell}
                            removeRow={removeRow}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default DynamicTableEditor;
